/* eslint-disable camelcase */

import { gql } from "@apollo/react-hooks";
import {
  CommandResult_ContractConcreteBatchingPlant,
  ListCommandResult_ContractConcreteBatchingPlant
} from "@graphql/helpers/types.graphql";
import {
  CommandResult,
  ListCommandResult
} from "@graphql/groups/fragment.graphql";
import utils, {
  TContractType,
  TNonEmptyArray,
  TJoin,
  TContractConcreteBatchingPlantType,
  TConcreteBatchingPlantType
} from "@graphql/helpers/utils.graphql";

type TGlobal =
  | TContractConcreteBatchingPlantType
  | TJoin<"contract", TContractType>
  | TJoin<"concreteBatchingPlant", TConcreteBatchingPlantType>;

type TContractConcreteBatchingPlantByIdFunctions = {
  getByID: CommandResult_ContractConcreteBatchingPlant;
};
export type TContractConcreteBatchingPlantByIdQueries = {
  contractConcreteBatchingPlant: TContractConcreteBatchingPlantByIdFunctions;
};

export const contractConcreteBatchingPlantById = (
  fields: TNonEmptyArray<TGlobal>
) => gql`
  query contractConcreteBatchingPlantById($id: Guid!) {
    contractConcreteBatchingPlant {
      getByID(id: $id) {
        ...COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${CommandResult("CommandResult_ContractConcreteBatchingPlant")}
`;

type TContractConcreteBatchingPlantAllWithPaginationFunctions = {
  getAllWithPagination: ListCommandResult_ContractConcreteBatchingPlant;
};
export type TContractConcreteBatchingPlantAllWithPaginationQueries = {
  contractConcreteBatchingPlant: TContractConcreteBatchingPlantAllWithPaginationFunctions;
};
export const contractConcreteBatchingPlantAllWithPagination = (
  fields: TNonEmptyArray<TGlobal>
) => gql`
  query contractConcreteBatchingPlantAllWithPagination($page: Int, $perPage: Int, $where: [WhereClausesInputType]) {
    contractConcreteBatchingPlant {
      getAllWithPagination(page: $page, perPage: $perPage, where: $where) {
        ...LIST_COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${ListCommandResult("ListCommandResult_ContractConcreteBatchingPlant")}
`;
